import * as zod from 'zod';

import { CameraIntegration } from '@sb/integrations/types/cameraTypes';

import { RegionOfInterest } from '../../vision/VisionInterface';

const DinoFastPrecision = zod.enum(['fast', 'standard', 'fine']);

const TemplateMatchClass = zod.object({
  name: zod.string(),
  storageID: zod.string(),
});

export const TemplateMatchClassifyMethod = zod.object({
  kind: zod.literal('TemplateMatch'),
  classes: zod.array(TemplateMatchClass).default([]),
});

const DinoFastClassifyExample = zod.object({
  storageID: zod.string(),
  embedding: zod.object({
    values: zod.array(zod.number()),
    modelVersion: zod.string(),
  }),
});

const DinoFastClassifyClass = zod.object({
  name: zod.string(),
  // No min-length: schema must accept in-progress configs (class with no
  // examples yet), or the saved routine fails to parse on next load and
  // the wizard reverts to TemplateMatch. UI + runner enforce non-emptiness.
  examples: zod.array(DinoFastClassifyExample),
});

export const DinoFastClassifyMethod = zod.object({
  kind: zod.literal('DinoFastClassify'),
  classes: zod.array(DinoFastClassifyClass).default([]),
  gpuTaskRunnerId: zod.string().default(''),
  embeddingModelVersion: zod.string().default('dinov3-vits16-v1-img'),
  precision: DinoFastPrecision.default('fast'),
});

export const ClassifyMethod = zod.discriminatedUnion('kind', [
  TemplateMatchClassifyMethod,
  DinoFastClassifyMethod,
]);

export default zod.object({
  method: ClassifyMethod.default({ kind: 'TemplateMatch', classes: [] }),
  fallbackValue: zod.string(),
  regionOfInterest: RegionOfInterest,
  confidence: zod.number(),
  camera: CameraIntegration.optional(),
  // Optional equipment ID for camera-bot-cpp mode (when set, camera field is ignored)
  cameraEquipmentId: zod.string().optional(),
});
